import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../../utils/dialogOverlay.js";
import { renderUyeliklerGrid } from "../../uyeliklerGrid.js";
import { uiState } from "../../../../state/uiState.js";
import { truncateLabel } from "../../../../utils/textPresentation.js";
import {
	PASSWORD_FOCUS_TEXT,
	PASSWORD_PLACEHOLDER,
	getPasswordValidationMessage,
} from "../../../../utils/passwordPolicy.js";

const API = "/api";
let didBind = false;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ensureUyeliklerCreateDialog() {
	if (document.getElementById("uyeliklerCreateDialog")) return;
	document.body.insertAdjacentHTML(
		"beforeend",
		`
<dialog id="uyeliklerCreateDialog">
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>\u00dcyelik Ekle</h4>
        </div>
        <div class="create-dialog-content">
            <div class="section">
                <div class="section-1-header"><h5>Ki\u015fi Se\u00e7imi</h5></div>
                <div class="section-1-content">
                    <div class="column-container uyelikler-kisi">
                        <label for="uyelikler_kisi">Ki\u015fi:</label>
                        <select id="uyelikler_kisi" name="kisi_tc" class="form-select" required>
                            <option value="" selected>Ki\u015fi se\u00e7iniz...</option>
                        </select>
                        <span class="info" data-focus="\u00dcyelik olu\u015fturulacak ki\u015fiyi se\u00e7in." data-invalid="Ki\u015fi se\u00e7ilmelidir."></span>
                    </div>
                    <div class="info-card-yeni">
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">T.C. Kimlik No</div>
                            <div class="info-card-yeni-deger info-card-yeni-deger--mono uyelikler-kisi-tc">\u2014</div>
                        </div>
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Ad</div>
                            <div class="info-card-yeni-deger uyelikler-kisi-ad">\u2014</div>
                        </div>
                        <div class="info-card-yeni-satir">
                            <div class="info-card-yeni-etiket">Soyad</div>
                            <div class="info-card-yeni-deger uyelikler-kisi-soyad">\u2014</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-divider"></div>
            <div class="section">
                <div class="section-1-header"><h5>\u00dcyelik Bilgileri</h5></div>
                <div class="section-1-content">
                    <div class="column-container uyelikler-email">
                        <label for="uyelikler_email">Email:</label>
                        <input id="uyelikler_email" class="form-input" type="text" name="email" maxlength="100" placeholder="ornek@kurumadi.com" required autocomplete="off" />
                        <span class="info" data-focus="\u00dcyenin email adresini girin." data-invalid="Ge\u00e7erli bir email adresi giriniz."></span>
                    </div>
                    <div class="column-container uyelikler-yetki">
                        <label for="uyelikler_yetki">Yetki:</label>
                        <select id="uyelikler_yetki" name="yetki_id" class="form-select" required>
                            <option value="" selected>Yetki se\u00e7iniz...</option>
                        </select>
                        <span class="info" data-focus="\u00dcyenin yetkisini se\u00e7in." data-invalid="Yetki se\u00e7ilmelidir."></span>
                    </div>
                    <div class="column-container uyelikler-sifre">
                        <label for="uyelikler_sifre">\u015eifre:</label>
                        <input id="uyelikler_sifre" class="form-input" type="password" name="sifre" maxlength="100" placeholder="${PASSWORD_PLACEHOLDER}" required autocomplete="new-password" />
                        <span class="info" data-focus="${PASSWORD_FOCUS_TEXT}"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="create-cancel">\u0130ptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`,
	);
}

export function initUyeliklerCreateDialog() {
	ensureUyeliklerCreateDialog();
	const dialog = document.querySelector("#uyeliklerCreateDialog");
	if (!dialog || didBind) return;
	didBind = true;

	const form = dialog.querySelector("form");
	const emailEl = dialog.querySelector("#uyelikler_email");
	const sifreEl = dialog.querySelector("#uyelikler_sifre");

	function syncEmailValidity() {
		const value = emailEl.value.trim();
		if (!value) {
			emailEl.setCustomValidity("");
			return;
		}
		if (!EMAIL_RE.test(value)) emailEl.setCustomValidity("Ge\u00e7erli bir email adresi giriniz.");
		else emailEl.setCustomValidity("");
	}

	emailEl.addEventListener("input", syncEmailValidity);
	emailEl.addEventListener("blur", syncEmailValidity);

	function syncSifreValidity() {
		const value = sifreEl.value;
		const infoSpan = sifreEl.parentElement.querySelector(".info");
		const errorText = getPasswordValidationMessage(value);
		if (errorText) {
			sifreEl.setCustomValidity(errorText);
			infoSpan?.setAttribute("data-invalid", errorText);
		} else {
			sifreEl.setCustomValidity("");
			infoSpan?.removeAttribute("data-invalid");
		}
	}

	sifreEl.addEventListener("input", syncSifreValidity);
	sifreEl.addEventListener("blur", syncSifreValidity);

	async function loadDropdowns() {
		const kisiSel = dialog.querySelector("#uyelikler_kisi");
		const yetkiSel = dialog.querySelector("#uyelikler_yetki");

		kisiSel.innerHTML = '<option value="" selected>Ki\u015fi se\u00e7iniz...</option>';
		yetkiSel.innerHTML = '<option value="" selected>Yetki se\u00e7iniz...</option>';

		try {
			const res = await fetch(`${API}/kisiler?durum=1`);
			const data = await res.json();
			(data.items || []).forEach((item) => {
				const fullLabel = `${item.first_name} ${item.last_name}`.trim();
				const opt = document.createElement("option");
				opt.value = item.tc;
				opt.textContent = truncateLabel(fullLabel, 32);
				opt.dataset.tc = item.tc;
				opt.dataset.firstName = item.first_name;
				opt.dataset.lastName = item.last_name;
				opt.title = fullLabel;
				kisiSel.appendChild(opt);
			});
		} catch (err) {
			console.error("Kisiler yuklenemedi:", err);
		}

		try {
			const res = await fetch(`${API}/yetkiler`);
			const data = await res.json();
			(data.items || []).forEach((item) => {
				const fullLabel = String(item.label || item.name || "");
				const opt = document.createElement("option");
				opt.value = item.id;
				opt.textContent = truncateLabel(fullLabel, 32);
				opt.title = fullLabel;
				yetkiSel.appendChild(opt);
			});
		} catch (err) {
			console.error("Yetkiler yuklenemedi:", err);
		}
	}

	dialog.querySelector("#uyelikler_kisi")?.addEventListener("change", (e) => {
		const selected = e.target.selectedOptions[0];
		const tcEl = dialog.querySelector(".uyelikler-kisi-tc");
		const adEl = dialog.querySelector(".uyelikler-kisi-ad");
		const soyadEl = dialog.querySelector(".uyelikler-kisi-soyad");
		if (selected?.value) {
			if (tcEl) tcEl.textContent = selected.dataset.tc ?? "\u2014";
			if (adEl) adEl.textContent = selected.dataset.firstName ?? "\u2014";
			if (soyadEl) soyadEl.textContent = selected.dataset.lastName ?? "\u2014";
		} else {
			if (tcEl) tcEl.textContent = "\u2014";
			if (adEl) adEl.textContent = "\u2014";
			if (soyadEl) soyadEl.textContent = "\u2014";
		}
	});

	document.body.addEventListener("click", async (e) => {
		if (e.target.closest(".uyelikler-ekle")) {
			dialog.showModal();
			dialog.scrollTop = 0;
			showDialogOverlay(dialog, "Y\u00fckleniyor...");
			await new Promise((r) => setTimeout(r, 350));
			try {
				await loadDropdowns();
			} finally {
				hideDialogOverlay();
			}
		}
		if (e.target.closest("#uyeliklerCreateDialog .create-cancel")) {
			dialog.close();
		}
	});

	dialog.addEventListener("close", () => {
		delete dialog.dataset.submitted;
		form?.reset();
		emailEl?.setCustomValidity("");
		sifreEl?.setCustomValidity("");
		dialog.querySelector(".uyelikler-kisi-tc").textContent = "\u2014";
		dialog.querySelector(".uyelikler-kisi-ad").textContent = "\u2014";
		dialog.querySelector(".uyelikler-kisi-soyad").textContent = "\u2014";
		dialog.querySelector("#uyelikler_sifre")?.parentElement?.querySelector(".info")?.removeAttribute("data-invalid");
	});

	if (form && !form._bound) {
		form._bound = true;

		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			dialog.dataset.submitted = "true";
			syncSifreValidity();

			if (!form.checkValidity()) {
				showToast("L\u00fctfen t\u00fcm zorunlu alanlar\u0131 doldurunuz.", "error");
				form.querySelector(":invalid")?.scrollIntoView({
					behavior: "smooth",
					block: "center",
				});
				return;
			}

			const kisi_tc = dialog.querySelector("#uyelikler_kisi")?.value;
			const email = emailEl?.value.trim();
			const yetki_id = Number(dialog.querySelector("#uyelikler_yetki")?.value);
			const sifre = sifreEl?.value;

			showDialogOverlay(dialog);
			await new Promise((r) => setTimeout(r, 350));
			try {
				const res = await fetch(`${API}/uyeler`, {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ kisi_tc, email, yetki_id, sifre }),
				});
				const data = await res.json();
				if (!data.ok) {
					showToast(data.error || "Kay\u0131t s\u0131ras\u0131nda hata olu\u015ftu.", "error");
					return;
				}
				showToast("\u00dcyelik ba\u015far\u0131yla olu\u015fturuldu.", "success", false);
				dialog.close();
				const refreshUrl = uiState.uyelikler.lastSearchUrl ?? `${API}/uyeler`;
				renderUyeliklerGrid({
					url: refreshUrl,
					paginationLimit: uiState.uyelikler.paginationLimit,
				});
			} catch (err) {
				console.error("POST /uyeler hatasi:", err);
				showToast("Sunucuya ba\u011flan\u0131lamad\u0131.", "error");
			} finally {
				hideDialogOverlay();
			}
		});
	}
}

function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#uyeliklerCreateDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}
